/**
 * Styled Components - Created by david on 09/04/18.
 */
interface RowProps {
  noBorder?: boolean
  rowPadding?: string
}

import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import { GRAY_DARK, BLUE } from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'
import Popover from 'antd/lib/popover'

export const Container = styled.div``

export const Table = styled.div`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  font-family: Avenir;
  @media (min-width: 320px) and (max-width: 480px) {
    margin-bottom: 0;
  }
  .grabbable:active {
    transform: translate3d(0px, 0px, 0px);
    cursor: grabbing;
    border-radius: 8px;
    outline: 1px solid #31eaff;
  }
  .placeholders {
    height: 0px;
    background: #f1f9f8;
    border-radius: 8px;
    transition: height .25s;
    box-shadow: inset 0 0 0 1px #27e1fd;
  }
`

export const InfoIcon = styled(Icon)`
  font-size: 12px;
`

export const PopoverStyled = styled(Popover)`
  cursor: pointer;
  z-index: 2;
`

export const PopoverText = styled.div`
  max-width: 382px;
  width: 100%;
  span {
    display: block;
    text-align: center;
    margin-bottom: 10px;
    text-transform: uppercase;
  }
`

export const Body = styled.tbody``

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: ${({ noBorder }: RowProps) => noBorder ? 'none' : '1px solid #D7D1D2'};
  padding: ${({ rowPadding }) => (rowPadding ? rowPadding : '8px 0')};
  cursor: move;
  border-radius: 8px;
  margin-top: 10px;
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-between;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F7F7F7;
  border-radius: 8px;
  padding: 10px 0;
  @media (max-width: 698px) {
    display: none;
  }
  &.fixed {
    padding-top: 32px;
  }
`

export const Column = styled.td`
  outline: 1px solid red;
  padding: 0;
`

interface CellProps {
  width?: number
  secondary?: boolean
  tabletWidth?: number
}
export const Cell = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width ${({ width }: CellProps) => (width ? width : 10)}%;
  @media (min-width: 425px) and (max-width: 768px) {
    width ${({ tabletWidth }: CellProps) => (tabletWidth ? tabletWidth : 10)}%;
  }
`

interface TitleProps {
  align?: string
}

export const Title = styled.div`
  max-width: 58px;
  width: 100%;
  color: ${GRAY_DARK};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 20px;
  z-index: 2;
  text-align: ${({ align }: TitleProps) => (align ? align : 'center')};
  &.wide {
    max-width: 72px;
    font-style: italic;
  }
`

export const Price = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 43px;
  text-transform: uppercase;
  width: 58px;
  text-align: ${({ align }: TitleProps) => (align ? align : 'center')};
  &.semibold {
    font-weight: 500;
  }
  &.prlbl {
    font-weight: 500;
    font-style: italic;
  }
`

export const MoreIcon = styled(Icon)`
  transform: rotate(90deg);
  font-size: 30px;
  margin-right: -19px;
`

export const MobileLocker = styled.div`
  display: none;
  flex-flow: column;
  border: 1px solid #D7D1D2;
  padding: 8px 0;
  border-radius: 8px;
  margin-top: 10px;
  @media (max-width: 698px) {
    display: flex;
  }
  .thmbnl {
    max-width: 118px;
  }
  .topLbls {
    display: flex;
    padding: 6px 8px 0;
    align-items: flex-start;
  }
  .priceDiv {
    display: flex;
    font-weight: 500;
    margin-top: 4px;
    span {
      width: 78px;
      ${({ secondary }: CellProps) => secondary ? `
        width: 100px;
        align-self: center;
      ` : ''}
    }
  }
  .price {
    text-transform: uppercase;
    white-space: nowrap;
  }
  @media (max-width: 360px) {
    .thmbnl {
      max-width: 80px;
    }
  }
`

export const Estimator = styled.div`
  background: #F0FFF0;
  margin-block: 4px -8px;
  border-radius: 0 0 7px 7px;
  padding: 8px 12px;
  .estTitle {
    font-weight: bold;
    justify-content: space-between;
    display: flex;
  }
  .collapsable {
    overflow: hidden;
    transition: max-height .25s;
    font-weight: 500;
    font-style: italic;
    max-height: ${({ secondary }: CellProps) => secondary ? '88px' : '0'};
  }
  .left {
    width: 60%
    text-align: right;
    margin-right: 14px;
  }
  .right {
    width: 40%;
  }
`

export const DesktopLocker = styled.div`
  background: white;
  @media (max-width: 698px) {
    display: none;
  }
`

export const DragCell = styled.div`
  display: flex;
  @media (max-width: 1024px) {
    display: none;
  }
`

export const DeleteButton = styled.div`
  user-select: none;
  color: #e61737;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 43px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  text-decoration: underline;
  @media (max-width: 698px) {
    line-height: unset;
    text-align: right;
  }
`

export const NameDiv = styled.div``

export const NameFixed = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
`

export const DescriptionFixed = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const Name = styled.div`
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  overflow-wrap: anywhere;
  @media (max-width: 698px) {
    font-size: 14px;
    line-height: 1.5;
    margin-right: 0;
  }
`

export const Description = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
  margin: 0 12px;
  p:last-child {
    margin-bottom: 0;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
    margin: 0;
  }
`
export const MobileEmtpytable = styled.div`
  padding: 50px 40px 50px;
  border-bottom: 1px solid #dcdcdc;
  color: #bebebe;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 21px;
  text-align: center;
`

export const Question = styled(Icon)`
  font-size: 16px;
  cursor: pointer;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const TeamPrice = styled.span`
  font-weight: bold;
`

export const ThumbnailDiv = styled.div`
  position: relative;
  @media (max-width: 698px) {
    > div img {
      height: 116px;
    }
  }
`

export const StatusFlag = styled.img`
  position: absolute;
  height: 28px;
  right: 4px;
  top: 3px;
  z-index: 8;
  border-top-right-radius: 5px;
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const SquareBox = styled.div`
  position: absolute;
  top: -28px;
  left: -4px;
  width: calc(100% * 4);
  height: calc(100% + 32px);
  background: #efffef;
`

export const TopLabel = styled.div`
  padding: 4px;
  font-weight: 500;
  font-family: Avenir;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-left: 8px;
  }
`

export const FloatingLabel = styled.div`
  position: absolute;
  left: 0;
  top: -30px;
  white-space: nowrap;
  width: calc(100% * 4);
  font-size: 12px;
  padding-right: 10px;
  text-align: center;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/LockerTable/styledComponents.tsx